import {
  axios
} from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getUserBindInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/getUserBindInfo`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeBindStep({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/changeBindStep`, {
          params
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  applyBindBankCard({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBindOffline/applyBindBankCard`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setCompanyInfo({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBindOffline/setCompanyInfo`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setAddCard({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBindOffline/setAddCard`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  signContract({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/signContract`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setRealName({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/setRealName`, {
          params
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendVerificationCode({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/sendVerificationCode`, {
          params
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  bindPhone({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/bindPhone`, {
          params
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  bindFile({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBindOffline/bindFile`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getOrgInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/getOrgInfo`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  applyNewBindBankCard({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBindOffline/applyNewBindBankCard`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllBindCard({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/getAllBindCard`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  unbindBankCard({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBindOffline/unbindBankCard`, {
          params
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  uploadTrue({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`yunBindOffline/uploadFile`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
};
